import classNames from 'classnames';
import React from 'react';
import { To } from 'react-router';
import { notNil } from '../../core/helpers/is-nil';
import { IconVariant, PictoVariant } from '../icon/icon-data';
import { Link } from '../link/link';
import { Typography } from '../typography/typography';
import { Icon } from '../icon/icon';
import ScanBox from './assets/scan-box.svg?react';
import styles from './highlight-box.module.scss';

type BaseProps = {
  title: string;
  text: string;
  className?: string;
};

type LinkProps = {
  text: string;
  icon: IconVariant;
  to: To;
};

type FeatureVariant = {
  variant: 'feature';
  link: LinkProps;
};

type GenericVariant = {
  variant: 'generic';
  picto?: PictoVariant;
  link?: LinkProps;
};

type Props = BaseProps & (FeatureVariant | GenericVariant);

export const HighlightBox: React.FC<Props> = (props) => {
  const { variant, title, text, link, className } = props;
  const isFeatureVariant = variant === 'feature';
  const isGenericVariant = variant === 'generic';
  const hasLink = notNil(link);
  return (
    <div className={classNames(styles.root, { [styles.isFeature]: isFeatureVariant }, className)}>
      <div className={styles.contentContainer}>
        <div className={classNames(styles.textContainer, { [styles.isFeature]: isFeatureVariant })}>
          <Typography variant="headline-3">{title}</Typography>
          <Typography variant="maintext">{text}</Typography>
        </div>
        {hasLink ? (
          <Link icon={link.icon} iconPosition="left" to={link.to}>
            {link.text}
          </Link>
        ) : null}
      </div>
      {isGenericVariant && notNil(props.picto) ? (
        <Icon className={styles.genericIcon} size="32" variant={props.picto} />
      ) : null}
      {isFeatureVariant ? <ScanBox className={styles.featureIcon} /> : null}
    </div>
  );
};
